import { defaultRequest } from 'api/auth'

export const constantAll = async () =>
  await defaultRequest('/api/constant/v1/all')
